import { Youtube, Facebook, Instagram, Linkedin } from 'lucide-react'

const Footer = () => {
  const socialLinks = [
    { icon: Youtube, href: 'https://youtube.com/c/grupofcamara', label: 'YouTube' },
    { icon: Facebook, href: 'https://www.facebook.com/grupo.fcamara', label: 'Facebook' },
    { icon: Instagram, href: 'https://www.instagram.com/grupo.fcamara/', label: 'Instagram' },
    { icon: Linkedin, href: 'https://br.linkedin.com/company/grupofcamara', label: 'LinkedIn' },
  ]

  return (
    <footer className="border-t border-border bg-background py-12">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
          >
            <span className="text-xl font-bold text-gradient">AI</span>
            <span className="text-xl font-bold text-foreground">Sym</span>
          </button>

          <div className="text-center">
            <p className="text-muted-foreground text-sm">
              Powered by{' '}
              <a
                href="https://fcamara.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary font-semibold hover:underline"
              >
                FCamara
              </a>
            </p>
            <p className="text-muted-foreground text-sm mt-1">
              <span className="font-bold">Tech</span> first.{' '}
              <span className="font-bold">Business</span> always.{' '}
              <span className="font-bold">AI</span> now.
            </p>
            <p className="text-muted-foreground text-sm mt-2">
              Precisa de ajuda? Fale conosco em{' '}
              <a href="mailto:aisym@fcamara.com" className="text-primary hover:underline">
                aisym@fcamara.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 mt-4">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="text-muted-foreground hover:text-primary transition-colors duration-200"
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          <p className="text-muted-foreground text-xs">
            © 2026 AI Sym. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
